"use strict";

(function (global) {
  /**
   * Функции отвечающие за работу с результатами выполнения заданиями.
   * @namespace Core.performResults
   * @since 5.7.0
   */
  global.performResults = {};
})(window.Core.jobs);

(function (global) {

  global.performResultsInit = $.Deferred();
  _performResults = {};
 
  global.init = (performResults) => {
    this._performResults = performResults;
    global.performResultsInit.resolve();
  } 

  /**
   * Возвращает результат выполнения по коду.
   *
   * @function Core.jobs.performResults.getByCode
   * @param {string} code Код результата выполнения.
   * @return {<object>} Результат выполнения.
   * @since 5.7.0
   */
  global.getByCode = (code) => {
    return _performResults.find(res => res.Code === code);
  }

  /**
   * Возвращает все результаты выполнения.
   *
   * @function Core.jobs.performResults.getAll   
   * @return {array<object>} Перечень вариантов выполнения задания.
   * @since 5.7.0
   */
  global.getAll = () => {
   return _performResults;
  }

})(window.Core.jobs.performResults)
